@if (hidenVertical) {
  <div class="px-8 py-4 bg-white rounded-lg gap-4 flex lg:px-4 lg:py-8 lg:flex-col shadow">
    @for (toll of tollArray; track $index) {
      @switch (toll.type) {
        @case ('scroll') {
          @if (!hidenScrollRight && toll.function === 'scrollRight') {
            <button
              mat-fab
              class="bg-white! text-general rounded-2xl! h-10!"
              (click)="mainButtonPress(toll)"
              [matTooltip]="toll.tolltip"
              matTooltipPosition="above"
              [disabled]="disableSaveFrom === 'INVALID'"
            >
              <mat-icon class="m-auto! aa-color-ic text-primary">{{ toll.icon }}</mat-icon>
            </button>
          }
          @if (!hidenScrollLeft && toll.function === 'scrollLeft') {
            <button
              mat-fab
              class="bg-white! text-general rounded-2xl! h-10!"
              (click)="mainButtonPress(toll)"
              [matTooltip]="toll.tolltip"
              matTooltipPosition="above"
              [disabled]="disableSaveFrom === 'INVALID'"
            >
              <mat-icon class="m-auto! aa-color-ic text-primary">{{ toll.icon }}</mat-icon>
            </button>
          }
        }
        @case ('normal') {
          <button
            mat-fab
            class="bg-white! text-general rounded-2xl! h-10!"
            (click)="mainButtonPress(toll)"
            [matTooltip]="toll.tolltip"
            matTooltipPosition="above"
            [disabled]="disableSaveFrom === 'INVALID' && toll.function === 'saveFrom'"
          >
            <mat-icon class="m-auto! aa-color-ic text-primary">{{ toll.icon }}</mat-icon>
          </button>
        }
        @case ('green') {
          <button
            mat-fab
            class="bg-white! aa-border-button-green text-general rounded-2xl! h-10!"
            (click)="mainButtonPress(toll)"
            [matTooltip]="toll.tolltip"
            matTooltipPosition="above"
            [disabled]="disableSaveFrom === 'INVALID' && toll.function === 'saveFrom'"
          >
            <mat-icon class="m-auto! aa-color-ic text-customGreen">{{ toll.icon }}</mat-icon>
          </button>
        }
        @case ('red') {
          <button
            mat-fab
            class="bg-white! aa-border-button-alert text-general rounded-2xl! h-10!"
            (click)="mainButtonPress(toll)"
            [matTooltip]="toll.tolltip"
            matTooltipPosition="above"
            [disabled]="disableSaveFrom === 'INVALID' && toll.function === 'saveFrom'"
          >
            <mat-icon class="m-auto! aa-color-ic">{{ toll.icon }}</mat-icon>
          </button>
        }
      }
    }
  </div>
} @else {
  <div class="flex gap-2">
    @for (toll of tollArray; track $index) {
      @switch (toll.type) {
        @case ('scroll') {
          @if (!hidenScrollRight && toll.function === 'scrollRight') {
            <button
              mat-fab
              class="bg-white! text-general rounded-2xl! h-10!"
              (click)="mainButtonPress(toll)"
              [matTooltip]="toll.tolltip"
              matTooltipPosition="above"
              [disabled]="disableSaveFrom === 'INVALID'"
            >
              <mat-icon class="m-auto! aa-color-ic text-primary">{{ toll.icon }}</mat-icon>
            </button>
          }
          @if (!hidenScrollLeft && toll.function === 'scrollLeft') {
            <button
              mat-fab
              class="bg-white! text-general rounded-2xl! h-10!"
              (click)="mainButtonPress(toll)"
              [matTooltip]="toll.tolltip"
              matTooltipPosition="above"
              [disabled]="disableSaveFrom === 'INVALID'"
            >
              <mat-icon class="m-auto! aa-color-ic text-primary">{{ toll.icon }}</mat-icon>
            </button>
          }
        }
        @case ('normal') {
          <button
            mat-fab
            class="bg-white! text-general rounded-2xl! h-10!"
            (click)="mainButtonPress(toll)"
            [matTooltip]="toll.tolltip"
            matTooltipPosition="above"
            [disabled]="disableSaveFrom === 'INVALID' && toll.function === 'saveFrom'"
          >
            <mat-icon class="m-auto! aa-color-ic text-primary">{{ toll.icon }}</mat-icon>
          </button>
        }
        @case ('green') {
          <button
            mat-fab
            class="bg-white! aa-border-button-green text-general rounded-2xl! h-10!"
            (click)="mainButtonPress(toll)"
            [matTooltip]="toll.tolltip"
            matTooltipPosition="above"
            [disabled]="disableSaveFrom === 'INVALID' && toll.function === 'saveFrom'"
          >
            <mat-icon class="m-auto! aa-color-ic text-customGreen">{{ toll.icon }}</mat-icon>
          </button>
        }
        @case ('red') {
          <button
            mat-fab
            class="bg-white! aa-border-button-alert text-general rounded-2xl! h-10!"
            (click)="mainButtonPress(toll)"
            [matTooltip]="toll.tolltip"
            matTooltipPosition="above"
            [disabled]="disableSaveFrom === 'INVALID' && toll.function === 'saveFrom'"
          >
            <mat-icon class="m-auto! aa-color-ic text-customAlert">{{ toll.icon }}</mat-icon>
          </button>
        }
      }
    }
  </div>
}
